import * as React from "react";

import { cn } from "../../lib/utils";

export type ButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: "default" | "outline";
  size?: "default" | "sm";
};

export const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className, variant = "default", size = "default", ...props }, ref) => {
    return (
      <button
        ref={ref}
        className={cn(
          "inline-flex items-center justify-center whitespace-nowrap font-semibold transition focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-tbd-almond/30",
          "disabled:pointer-events-none disabled:opacity-50",
          "rounded-[3px] border",
          size === "default" && "h-11 px-5 text-[14px]",
          size === "sm" && "h-9 px-4 text-[13px]",
          variant === "default" &&
            "border-tbd-charcoal/15 bg-tbd-almond text-tbd-charcoal shadow-[0_14px_34px_rgba(43,48,44,0.14)] hover:bg-tbd-sage",
          variant === "outline" &&
            "border-tbd-charcoal/18 bg-transparent text-tbd-charcoal hover:bg-tbd-charcoal/5",
          className
        )}
        {...props}
      />
    );
  }
);

Button.displayName = "Button";

